/** Index (0–7) of the current 3-hour window of the Damascus day. */
export function currentSegment(now = new Date()): number {
  const hour = Number(
    new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Damascus",
      hour: "2-digit",
      hour12: false,
    }).format(now),
  );
  return Math.floor((hour % 24) / 3);
}
